import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AxiosResponse, HttpStatusCode } from 'axios';

import { useApi } from '../../../../context/ApiProvider';
import { PaginationInterface } from '../../../../shared/type/paginationInterface.type';
import { PaymentInterface } from '../../../../shared/type/payment.type';
import { useAlertContext } from '../../../../context/AlertProvider';

const formatDateToRequest = (date: string | undefined) => {
  if (!date) return '';

  const [year, month, day] = date.split('-');
  return `${year}-${month}-${day}`;
};

export const useTenantTransactionList = () => {
  const today = new Date();
  const { id: tenantId } = useParams();
  const { setShow, setAlertProperties } = useAlertContext();
  const { apiTenantAdminPaymentController } = useApi();
  const [isLoading, setIsLoading] = useState(false);
  const [listOfPayments, setListOfPayments] = useState<PaymentInterface[] | undefined>(undefined);
  const [dateScope, setDateScope] = useState<{
    start: string | undefined;
    end: string | undefined;
  }>({
    start: today.toISOString().split('T')[0],
    end: today.toISOString().split('T')[0]
  });

  const fetchListOfPayments = async () => {
    setIsLoading(true);
    try {
      const response: AxiosResponse<PaymentInterface[]> = await apiTenantAdminPaymentController(
        'list-payments'
      ).post('', {
        tenantId: Number(tenantId),
        from: formatDateToRequest(dateScope.start),
        to: formatDateToRequest(dateScope.end),
        searchPhrase: ''
      });

      if (response.status !== HttpStatusCode.Ok) return;

      setListOfPayments(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleStartDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newStartDate = event.target.value;

//poniższy kod zostal zakomentowany, no wraz ze zmianą daty początkowej zmieniam też datę końcową na ten sam dzień
//     // Walidacja: data początkowa musi być wcześniejsza niż końcowa
//     if (dateScope.end && newStartDate > dateScope.end) {
//       setAlertProperties({
//         timeout: 9000,
//         status: 'warning',
//         title: 'Uwaga',
//         description: 'Data początkowa musi być wcześniejsza niż data końcowa.'
//       });
//       setShow(true);
//       return;
//     }

    // Unikamy niepotrzebnej aktualizacji stanu
    if (dateScope.start !== newStartDate) {
      setDateScope((prev) => ({ ...prev, start: newStartDate, end: newStartDate }));
    }
  };

  const handleEndDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newEndDate = event.target.value;

    // Walidacja: data końcowa musi być późniejsza niż początkowa
    if (dateScope.start && newEndDate < dateScope.start) {
      setAlertProperties({
        timeout: 9000,
        status: 'warning',
        title: 'Uwaga',
        description: 'Data końcowa musi być późniejsza niż data początkowa.'
      });
      setShow(true);
      return;
    }

    // Unikamy niepotrzebnej aktualizacji stanu
    if (dateScope.end !== newEndDate) {
      setDateScope((prev) => ({ ...prev, end: newEndDate }));
    }
  };

  useEffect(() => {
    console.log('hello');
    if (!tenantId) return;
    fetchListOfPayments();
  }, [tenantId, dateScope]);

  return {
    listOfPayments,
    isLoading,
    dateScope,
    handleStartDateChange,
    handleEndDateChange
  };
};
